
export const dashboardCardData = (dashBorardUpperData) => {
  return [
    {
      id: 1,
      title: "Completed Trips",
      subTitle: dashBorardUpperData?.totalfinishedrides || "0",
    },
    {
      id: 2,
      title: "Ongoing Trips",
      subTitle: dashBorardUpperData?.activerides || "0",
    },
    {
      id: 3,
      title: "Booked Trips",
      subTitle: dashBorardUpperData?.upcomingRides || "0",
    },
    {
      id: 4,
      title: "Cancelled Trips",
      subTitle: dashBorardUpperData?.canceledRides || "0",
    },
    {
      id: 5,
      title: "Total Drivers",
      subTitle: dashBorardUpperData?.totalDriver || "0",
    },
  ];
};

//TODO: this datas are static, after the api integration we will remove this file

// export const updateCompanyDoc = () => {
//   let obj = ''
//   return(obj = { 'Contract Details' :[
//     {
//       datePicker: true,
//       required: true,
//       gridSize: 12,
//       placeholder: "",
//       type: "date",
//       name: "chooseDate",
//       label: "Contract Date",
//     },
//     {
//       dateRangePicker: true,
//       required: true,
//       gridSize: 12,
//       placeholder: "",
//       type: "",
//       name: "tenure",
//       label: "Tenure",
//     },
//     {
//       fileUpload: true,
//       required: true,
//       gridSize: 12,
//       name: "InsuranceFile",
//       label: "Upload Agreement",
//       placeholder:"Upload New Contract"
//     },
//   ]})
// }
